<div>
    <div class="payment-method" *ngIf="(viewport.width$ | async)! > 680; else phoneMethodSelector">
        <h3 class="screen-reader-text">Payment Method</h3>
        <mat-tab-group mat-align-tabs="center" class="_title-tabs" (selectedTabChange)="tabChanged($event.tab.textLabel)" [selectedIndex]="tabIndex$ | async">
            <mat-tab *ngIf="allowSelectingExisting$ | async" label="EXISTING">
                <ng-template mat-tab-label>
                    Existing
                    <ng-container *ngIf="(viewport.width$ | async)! > 1400">Payment Method</ng-container>
                </ng-template>
            </mat-tab>
            <mat-tab *ngFor="let methodId of allowedPaymentTypes$ | async" [label]="methodId" [disabled]="(enabled$ | async) === false">
                <ng-template mat-tab-label>
                    <ng-container *ngIf="methodId === 'CREDIT'">US Credit Card</ng-container>
                    <ng-container *ngIf="methodId === 'CREDIT_INTL'">Non-US Credit Card</ng-container>
                    <ng-container *ngIf="methodId === 'ECHECK'">E-check</ng-container>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
    <ng-template #phoneMethodSelector>
        <div class="payment-method phone">
            <mat-form-field appearance="standard" [hideRequiredMarker]="true">
                <mat-label>Payment Method</mat-label>
                <mat-select required [value]="selectedPaymentOption$ | async" (selectionChange)="selectChanged($event)">
                    <mat-option value="EXISTING" *ngIf="allowSelectingExisting$ | async">
                        Existing Payment Method
                    </mat-option>
                    <mat-option *ngIf="(allowedPaymentTypes$ | async)?.indexOf($any('CREDIT')) !== -1" value="CREDIT">US Credit Card</mat-option>
                    <mat-option *ngIf="(allowedPaymentTypes$ | async)?.indexOf($any('CREDIT_INTL')) !== -1" value="CREDIT_INTL">Non-US Credit Card</mat-option>
                    <mat-option *ngIf="(allowedPaymentTypes$ | async)?.indexOf($any('ECHECK')) !== -1" value="ECHECK">E-check</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </ng-template>
    <ng-content></ng-content>
    <ng-container *ngIf="!hideContent">
        <!--app-payment-method-selection-list
            *ngIf="(selectedPaymentOption$ | async) == 'EXISTING'"
            [selectedPaymentMethod]="selectedExistingPaymentMethod"
            [allowCreation]="false"
            [allowDeselection]="false"
            (itemSelected)="existingPaymentMethodSelected.emit($event)"
        ></app-payment-method-selection-list-->
        <div class="all-fields" [class.continues-below]="continuesBelow" *ngIf="(selectedPaymentOption$ | async) !== 'EXISTING'">
            <ng-content select=".right-above-the-fields"></ng-content>
            <div class="fields card" *ngIf="(selectedPaymentOption$ | async) === 'CREDIT' || (selectedPaymentOption$ | async) === 'CREDIT_INTL'">
                <div class="card-fields">
                    <mat-form-field appearance="standard" class="card-number" [hideRequiredMarker]="true">
                        <mat-label>Card Number</mat-label>
                        <input
                            matInput
                            type="tel"
                            [formControl]="cardNumber"
                            [egovCleave]="{ creditCard: true }"
                            (creditCardTypeChanged)="updateCardType($event)"
                            (valueChanged)="cardNumberValue = $event.target.value; cardNumberRawValue = $event.target.rawValue"
                        />
                    </mat-form-field>

                    <mat-form-field appearance="standard" class="name" [hideRequiredMarker]="true">
                        <mat-label>Name on Card</mat-label>
                        <input matInput type="text" [formControl]="name" />
                    </mat-form-field>

                    <div class="expiration-cv2">
                        <div class="expiration-cv2-inner">
                            <div class="expiration">
                                <mat-form-field appearance="standard" [hideRequiredMarker]="true">
                                    <mat-label>Expiration</mat-label>
                                    <input
                                        matInput
                                        type="tel"
                                        maxlength="5"
                                        [formControl]="expiration"
                                        placeholder="MM/YY"
                                        [egovCleave]="{ date: true, datePattern: ['m', 'y'] }"
                                        (valueChanged)="expirationValue = $event.target.value"
                                    />
                                </mat-form-field>
                            </div>
                            <div class="cv2">
                                <mat-form-field appearance="standard" [hideRequiredMarker]="true">
                                    <mat-label>CV2 Code</mat-label>
                                    <input
                                        matInput
                                        type="text"
                                        maxlength="4"
                                        pattern="\d*"
                                        [formControl]="cv2"
                                        [egovCleave]="{ blocks: [4] }"
                                        (focus)="cv2Focused = true"
                                        (blur)="cv2Focused = false"
                                        (valueChanged)="cv2Value = $event.target.rawValue"
                                    />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </div>

                <egov-card-visualization
                    *ngIf="(viewport.phone$ | async) === false"
                    [flipped]="cv2Focused && (cardType$ | async) !== 'amex'"
                    [cardType]="cardType$ | async"
                    [cardNumber]="cardNumberValue"
                    [nameOnCard]="name.value"
                    [cardExpiration]="expirationValue"
                    [cv2]="cv2Value"
                ></egov-card-visualization>
            </div>

            <div class="fields echeck" *ngIf="(selectedPaymentOption$ | async) === 'ECHECK'">
                <mat-form-field class="name" appearance="standard" [hideRequiredMarker]="true">
                    <mat-label>Name on Check</mat-label>
                    <input matInput type="text" [formControl]="name" />
                </mat-form-field>

                <div class="echeck-info">
                    <div>
                        <mat-form-field class="routing-number" appearance="standard" [hideRequiredMarker]="true">
                            <mat-label>Routing Number</mat-label>
                            <input matInput type="tel" [formControl]="routingNumber" autocomplete="off" />
                            <div matSuffix class="tip" (click)="showSmallScreensEcheckHelp()">
                                <div class="badge">?</div>
                            </div>
                            <mat-hint *ngIf="(routingNumberStatus$ | async) === 'wrong-length'">
                                The routing number must have 9 digits
                            </mat-hint>
                            <mat-hint *ngIf="(routingNumberStatus$ | async) === 'validating'">
                                Validating...
                            </mat-hint>
                            <mat-hint *ngIf="(routingNumberStatus$ | async) === 'invalid'" class="error">
                                Invalid routing number
                            </mat-hint>
                            <mat-hint *ngIf="(routingNumberStatus$ | async) === 'valid'" class="echeck-validation-info">
                                <div class="values">
                                    <div class="value" *ngIf="(routingNumberValidationResponse$ | async)!.name">
                                        <mat-icon>person</mat-icon>
                                        {{ (routingNumberValidationResponse$ | async)!.name }}
                                    </div>
                                    <div class="value" *ngIf="(routingNumberValidationResponse$ | async)!.phone">
                                        <mat-icon>phone</mat-icon>
                                        {{ (routingNumberValidationResponse$ | async)!.phone }}
                                    </div>
                                </div>
                                <div class="wrong" [egovTooltip]="wrong">
                                    Wrong?
                                    <ng-template #wrong>
                                        If this information doesn't correspond to the account holder, please check the routing number entered.
                                    </ng-template>
                                </div>
                            </mat-hint>
                        </mat-form-field>
                        <mat-form-field class="account-number" appearance="standard" [hideRequiredMarker]="true">
                            <mat-label>
                                <egov-confirm-label *ngIf="accountNumberConfirm.confirming | async"> Confirm&nbsp; </egov-confirm-label>Account Number
                            </mat-label>
                            <input
                                matInput
                                type="text"
                                required
                                [formControl]="accountNumber"
                                egovConfirm
                                #accountNumberConfirm="egovConfirm"
                                [confirmImmediatelyOnValid]="false"
                                autocomplete="no"
                            />
                            <mat-error *ngIf="accountNumberConfirm.confirmationFailed$ | async">
                                Confirmation failed. Try again.
                            </mat-error>
                            <div matSuffix class="tip" (click)="showSmallScreensEcheckHelp()">
                                <div class="badge">?</div>
                            </div>
                        </mat-form-field>
                    </div>
                    <div class="echeck-help">
                        <egov-echeck-help type="arrows"></egov-echeck-help>
                    </div>
                </div>
            </div>

            <div class="fields">
                <mat-form-field class="address" appearance="standard" [hideRequiredMarker]="true">
                    <mat-label>Address</mat-label>
                    <input matInput type="text" [formControl]="address" />
                </mat-form-field>
                <mat-form-field class="zip" appearance="standard" *ngIf="(selectedPaymentOption$ | async) !== 'CREDIT_INTL'" [hideRequiredMarker]="true">
                    <mat-label>Billing ZIP</mat-label>
                    <input matInput type="tel" [formControl]="zip" maxlength="5" />
                </mat-form-field>
            </div>
        </div>
    </ng-container>
</div>
